import { request } from "@/service/request.js";

export function getCreateOrder(options) {
    return request.call(this, {
        url: "openapi/web/group/createOrder",
        method: 'POST',
        data: options
    });
}
